import React from 'react'

import SimpleTimeEditor from './SimpleTimeEditor'
import AdvancedTimeEditor from './AdvancedTimeEditor'
import JsonEditor from './JsonEditor'

const types = {
  [SimpleTimeEditor.TYPE] : SimpleTimeEditor,
  [AdvancedTimeEditor.TYPE] : AdvancedTimeEditor,
  [JsonEditor.TYPE] : JsonEditor
}

function queryFactory( type, query, props ) {
  const Editor = types[type]
  return Editor && <Editor query={query} {...props} />
}

exports.factory = queryFactory
